import { Position } from 'react-virtualized'
import { Client, ClientCashflow, ClientDeal, ClientName, ClientPerson, ClientRole, ClientTaxPosition, ClientTaxSummary } from '../redux/reducers/clients'
import { fetchRequest } from '../services/http.service'
import { Account, AccountDeal } from '../redux/reducers/portfolio'

export const GET_CLIENTS_URL = '/client/'
export const GET_CLIENT_URL = '/client/new'
export const POST_CLIENT_URL = '/client/create'
export const UPDATE_CLIENT_URL = '/client/update'
export const VALID_CLIENT_URL = '/client/valid'
export const DEACTIVATE_CLIENT_URL = `/client/deactivate`
export const GET_CLIENT_BY_PARAM_URL = 'client/'
export const GET_CLIENT_ROLES_LIST_URL = '/roles'
export const GET_CLIENT_PERSONS_LIST_URL = '/client/persons'
export const GET_CLIENT_DEAL_URL = '/transaction/deal'
export const GET_CLIENT_CASH_FLOW_URL = '/transaction/cashflow'
export const EXPOT_CLIENTS_URL = '/client/export'
export const GET_CLIENT_TAX_POSITION_URL = '/profitloss/position'
export const GET_CLIENT_TAX_POSITION_EXPORT_URL = '/profitloss/position/export'
export const GET_CLIENT_TAX_SUMMARY_URL = '/profitloss/summary'
export const GET_CLIENT_TAX_SUMMARY_EXPORT_URL = '/profitloss/summary/export'
export const GET_POSITION_BUYS_URL = `/position/detail`
export const GET_CLIENT_ACCOUNTS_URL = '/accounts/client'
export const CREATE_ACCOUNT_DEAL_URL = '/accountdeal'

export const getClientsRequest = () => fetchRequest.get<Client[]>(GET_CLIENTS_URL)

export const getClientRequest = (clientId: number) =>
  fetchRequest.get<Client>(GET_CLIENT_URL + `/${clientId}`, clientId)

export const postClientRequest = (client: Client) => fetchRequest.post<Client>(POST_CLIENT_URL, client)

export const updateClientRequest = (client: Client) => fetchRequest.put<Client>(UPDATE_CLIENT_URL, client)

export const validClientRequest = (client: Client) => fetchRequest.put<ClientName>(VALID_CLIENT_URL, client)

export const deactivateClientRequest = (client: Client) =>
  fetchRequest.put<Client>(DEACTIVATE_CLIENT_URL + `/${client.clientId}`, client)

export const getClientsByParamRequest = (instrument: string, role: string) => fetchRequest.get<Client[]>(GET_CLIENT_BY_PARAM_URL + getParams3(instrument, role))

export const getClientRolesRequest = () => fetchRequest.get<ClientRole[]>(GET_CLIENT_ROLES_LIST_URL)

export const getClientPersonsRequest = (clientId: number) => fetchRequest.get<ClientPerson[]>(GET_CLIENT_PERSONS_LIST_URL+'?clientId='+clientId)

export const getClientDealsRequest = (clientId: number, dateFrom: String, dateTo: String) => fetchRequest.get<ClientDeal[]>(GET_CLIENT_DEAL_URL + getParams(clientId, dateFrom, dateTo))

export const getClientCashflowRequest = (clientId: number, dateFrom: String, dateTo: String) => fetchRequest.get<ClientCashflow[]>(GET_CLIENT_CASH_FLOW_URL + getParams(clientId, dateFrom, dateTo))

export const exportClientsRequest = (clientsId: number[]) => fetchRequest.put<any>(EXPOT_CLIENTS_URL, {clientsId: clientsId})

export const getClientTaxPositionRequest = (clientId: number) => fetchRequest.get<ClientTaxPosition[]>(GET_CLIENT_TAX_POSITION_URL + '?clientId='+ clientId)

export const getClientTaxSummaryRequest = (clientId: number, dateFrom: String, dateTo: String) => fetchRequest.get<ClientTaxSummary[]>(GET_CLIENT_TAX_SUMMARY_URL + getParams(clientId, dateFrom, dateTo))

export const exportPositionRequest = (taxPosition: ClientTaxPosition, clientId : String, dateFrom: String, dateTo: String) => fetchRequest.put<any>(GET_CLIENT_TAX_POSITION_EXPORT_URL+getParams2(clientId, dateFrom, dateTo), taxPosition)

export const exportSummaryRequest = (taxSummary: ClientTaxSummary, clientId : String, dateFrom: String, dateTo: String) => fetchRequest.put<any>(GET_CLIENT_TAX_SUMMARY_EXPORT_URL+getParams2(clientId, dateFrom, dateTo), taxSummary)

export const getPositionBuysRequest = (positionId: Number) =>  fetchRequest.get<Position[]>(GET_POSITION_BUYS_URL + `?positionId=${positionId}`)

export const getClientAccountsRequest = (clientId: number) => fetchRequest.get<Account[]>(GET_CLIENT_ACCOUNTS_URL + '/' + clientId)

export const createAccountDealRequest = (accountDeal: AccountDeal) => fetchRequest.post<AccountDeal>(CREATE_ACCOUNT_DEAL_URL, accountDeal)

const getParams = (clientId: number, dateFrom: String, dateTo: String) => {
  let result = '';
  result += clientId ? 'clientId='+clientId : '';
  result += result ? ( dateFrom ? '&dateFrom='+dateFrom : '' ) : ( dateFrom ? 'dateFrom='+dateFrom : '' );
  result += result ? ( dateTo ? '&dateTo='+dateTo : '' ) : ( dateTo ? 'dateTo='+dateTo : '' );
  return result!==''?'?'+result:'';
}

const getParams2 = (clientId: String, dateFrom: String, dateTo: String) => {
  let result = '';
  result += clientId ? 'clientId='+clientId : '';
  result += result ? ( dateFrom ? '&dateFrom='+dateFrom : '' ) : ( dateFrom ? 'dateFrom='+dateFrom : '' );
  result += result ? ( dateTo ? '&dateTo='+dateTo : '' ) : ( dateTo ? 'dateTo='+dateTo : '' );
  return result!==''?'?'+result:'';
}

const getParams3 = (instrument: string, role: string) => {
  let result = '';
  result += instrument ? 'instrument='+instrument : '';
  result += result ? ( role ? '&roles='+role : '' ) : ( role ? 'roles='+role : '' );
  return result!==''?'?'+result:'';
}
